module.exports = __webpack_public_path__ + "img/073684.f8b35210.png";